export const HELP_PLATFORM = {
  APP: "APP",
  WEB: "WEB",
};

export const HELP_ACTION = {
  PUBLISH: "PUBLISH",
  UNPUBLISH: "UNPUBLISH",
  DELETE: "DELETE",
};
